export const USER_PROCORE_PREFERENCES = 'procorePreferences';
